export const server = "https://auctionserver.jansetu.co.in/api/v1";
// export const server = "http://192.168.88.76:5005/api/v1";

export const defaultUserImage = "";
